import { memo } from 'react'
import { Button, Popup } from 'common-components'
import * as Styled from '../styled'
import { ERROR_POPUP_IMAGE_URL } from '../consts'
import { T } from 'consts/translationKeys'
import { translate } from 'utils/translations'

const ErrorPopupContent = ({
  isOpen,
  description,
  title,
  buttonLabel,
  onClose,
  onButtonClick
}: {
  isOpen: boolean
  description: string
  title?: string
  buttonLabel?: string
  onClose: () => void
  onButtonClick: () => void
}) => (
  <Popup isOpen={isOpen} onClose={onClose}>
    <Styled.Container>
      <Styled.Image src={ERROR_POPUP_IMAGE_URL} alt="error" />
      {title && <Styled.Title>{title}</Styled.Title>}
      {description && <Styled.Description>{description}</Styled.Description>}
      <Button type="primary" onClick={onButtonClick}>
        {buttonLabel || translate(T.GOT_IT_LABEL)}
      </Button>
    </Styled.Container>
  </Popup>
)

export default memo(ErrorPopupContent)
